import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Apps } from "@mui/icons-material";
import Moment from 'moment';

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];
function PartnerUpdateModal({ title, onClose, id, handleView, originRows, typeModalOption, userTypeModalOption, userStatusModalOption, MenuUpdateYN }) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [addressRows, setAddressRows] = useState([]);
  const [updateAddressRows, setUpdateAddressRows] = useState([]);
  const [addressColumns, setAddressColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    partner_id: null,
    partner_name: '',
    partner_id:0,
    partner_type: 0,
    partner_number: '',
    partner_corp_number: '',
    partner_call: '',
    partner_fax: '',
    partner_ceo: '',
    partner_ceo_phone: '',
    partner_ceo_email: '',
    partner_head_address_post: '',
    partner_head_address: '',
    partner_head_address_addition: '',
    partner_industry: '',
    partner_business_type: '',
    partner_note: ''
  });
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));

  const handleInitSelect = () => {
    tmpRealFiles = [];
    setUpdateAddressRows([]);
    setUpdateUserRows([]);
    setUpdateFileRows([]);

    setInputs({
      partner_id: originRows[0].partner_id,
      partner_name: originRows[0].partner_name,
      partner_type: originRows[0].partner_type,
      partner_number: originRows[0].partner_number,
      partner_corp_number: originRows[0].partner_corp_number,
      partner_call: originRows[0].partner_call,
      partner_fax: originRows[0].partner_fax,
      partner_ceo: originRows[0].partner_ceo,
      partner_ceo_phone: originRows[0].partner_ceo_phone,
      partner_ceo_email: originRows[0].partner_ceo_email,
      partner_head_address_post: originRows[0].partner_head_address_post,
      partner_head_address: originRows[0].partner_head_address,
      partner_head_address_addition: originRows[0].partner_head_address_addition,
      partner_industry: originRows[0].partner_industry,
      partner_business_type: originRows[0].partner_business_type,
      partner_note: originRows[0].partner_note
    });

    // 거래처 담당자
    var userData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.partner_user_seq !== 'undefined' && item.partner_user_seq === item2.partner_user_seq && item.partner_user_name === item2.partner_user_name && item.partner_user_type === item2.partner_user_type
           && item.partner_user_call === item2.partner_user_call && item.partner_user_phone === item2.partner_user_phone && item.partner_user_email === item2.partner_user_email && item.partner_user_status === item2.partner_user_status;
        }) === index
      );
    });

    // 거래처 주소
    var addressData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.partner_address_seq !== 'undefined' && item.partner_address_seq === item2.partner_address_seq && item.partner_address_nickname === item2.partner_address_nickname && item.partner_address_post === item2.partner_address_post
           && item.partner_address === item2.partner_address && item.partner_address_addition === item2.partner_address_addition;
        }) === index
      );
    });

    // 거래처 파일
    var fileData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.partner_file_id !== 'undefined' && item.partner_file_id === item2.partner_file_id;
        }) === index
      );
    });

    fileData = fileData.sort(function(a, b) { 
      return a.partner_file_id < b.partner_file_id ? -1 : a.partner_file_id > b.partner_file_id ? 1 : 0;
    });

    setUserRows(userData.map((item, index) => ({
      id: item.partner_user_seq,
      partner_user_name: item.partner_user_name,
      partner_user_type: item.partner_user_type,
      partner_user_call: item.partner_user_call,
      partner_user_phone: item.partner_user_phone,
      partner_user_email: item.partner_user_email,
      partner_user_status: item.partner_user_status,
      row_type: 'O',
      update_type: 'N'
    })));
    
    setAddressRows(addressData.map((item, index) => ({
      id: item.partner_address_seq,
      partner_address_nickname: item.partner_address_nickname,
      partner_address_post: item.partner_address_post,
      partner_address: item.partner_address,
      partner_address_addition: item.partner_address_addition,
      reg_user_name: item.address_reg_user_name,
      reg_datetime: Moment(item.address_reg_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));
    
    setFileRows(fileData.map((item, index) => ({
      id: item.partner_file_id,
      file_name_sever: item.partner_file_name_sever,
      file_size: item.partner_file_size,
      file_type: item.partner_file_type,
      file_extension: item.partner_file_extension,
      file_name: item.partner_file_name,
      file_type_name: item.partner_file_type_name,
      file_size_dp: item.partner_file_size_dp,
      reg_user_name: item.partner_file_user_name,
      reg_datetime: Moment(item.partner_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));

    setOriginFileRows(fileData.map((item, index) => ({
      id: item.partner_file_id,
      file_name_sever: item.partner_file_name_sever,
      file_size: item.partner_file_size,
      file_type: item.partner_file_type,
      file_extension: item.partner_file_extension,
      file_name: item.partner_file_name,
      file_type_name: item.partner_file_type_name,
      file_size_dp: item.partner_file_size_dp,
      reg_user_name: item.partner_file_user_name,
      reg_datetime: Moment(item.partner_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));
    
    fileData.map((item, index) => 
      newFileID = (item.partner_file_id >= newFileID)?(item.partner_file_id)+1:newFileID,
    )
  }

  const handleSetting = () => {
    setAddressColumns([
      (MenuUpdateYN === "Y"?
        {
            field: 'actions',
            headerName: '동작',
            width: 55,
            type:'actions',
            disableClickEventBubbling: true,
            getActions: (params) => [
                ((params.row.update_type === "U")? 
                <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {addressDeleteClick(params)}} label="Delete" />
                : (params.row.row_type === "A" && params.row.update_type === "N")? 
                <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {addressAddClick(params)}} label="Add"  /> 
                :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {addressDeleteClick(params)}} label="Delete" />
                )
              ],
            headerAlign: 'center', 
            align:'center'
        } : {}),
        { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
        { field: 'partner_address_nickname', headerName: '주소 별칭', width: 200, headerAlign: 'center', editable: true },
        { field: 'partner_address_post', headerName: '우편번호', width: 100, headerAlign: 'center', align:'center', editable: true },
        { field: 'partner_address', headerName: '주소', width: 300, headerAlign: 'center', editable: true },
        { field: 'partner_address_addition', headerName: '상세주소', width: 200, headerAlign: 'center', editable: true },
        { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
        { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      (MenuUpdateYN === "Y"?
        {
            field: 'actions',
            headerName: '동작',
            width: 55,
            type:'actions',
            disableClickEventBubbling: true,
            getActions: (params) => [
                ((params.row.update_type === "U")? 
                <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                : (params.row.row_type === "A" && params.row.update_type === "N")? 
                <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
                :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                )
              ],
            headerAlign: 'center', 
            align:'center'
        } : {}),
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'partner_user_name', headerName: '담당자명', width: 130, headerAlign: 'center', editable: true },
      { field: 'partner_user_type', headerName: '담당자유형', type: 'singleSelect', width: 110, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'partner_user_call', headerName: '전화번호', width: 130, headerAlign: 'center', align:'center', editable: true },
      { field: 'partner_user_phone', headerName: '휴대폰번호', width: 150, headerAlign: 'center', align:'center', editable: true },
      { field: 'partner_user_email', headerName: '메일주소', width: 200, headerAlign: 'center', editable: true },
      { field: 'partner_user_status', headerName: '상태', type: 'singleSelect', width: 90, 
        valueOptions: () => userStatusModalOption ?? [], valueFormmatter: ({  value }) => 
        userStatusModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      (MenuUpdateYN === "Y"?
        {
          field: 'actions',
          headerName: '동작',
          width: 55,
          type:'actions',
          disableClickEventBubbling: true,
          getActions: (params) => [
              ((params.row.update_type === "U")? 
              <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
              : (params.row.row_type === "A" && params.row.update_type === "N")? 
              <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
              :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
              )
            ],
          headerAlign: 'center', 
          align:'center'
      } : {}),
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setAddressColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      partner_address_nickname: true,
      partner_address_post: true,
      partner_address: true,
      partner_address_addition: true,
      reg_user_name: true,
      reg_datetime: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      partner_user_name: true,
      partner_user_type: true,
      partner_user_call: true,
      partner_user_phone: true,
      partner_user_email: true,
      partner_user_status: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: updateFlag,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [addressColumnVisibilityModel, setAddressColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    partner_address_nickname: true,
    partner_address_post: true,
    partner_address: true,
    partner_address_addition: true,
    reg_user_name: true,
    reg_datetime: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    partner_user_name: true,
    partner_user_type: true,
    partner_user_call: true,
    partner_user_phone: true,
    partner_user_email: true,
    partner_user_status: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: updateFlag,
    download: true,
    row_type: false,
    update_type: false
  });
  
  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    tmpRealFiles = [];
    handleSetting();
    handleInitSelect();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  useEffect(() => {
    // addressRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<addressRows.length; i++){
      if(addressRows[i].row_type === 'A' && addressRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setAddressRows((addressRows) => [...addressRows, { 
        id: Number(appStore.getMaxListID(addressRows))+1,
        partner_address_nickname: '',
        partner_address_post: '',
        partner_address: '',
        partner_address_addition: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [addressRows]);

  useEffect(() => {
    // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        partner_user_name: '',
        partner_user_type: 0,
        partner_user_call: '',
        partner_user_phone: '',
        partner_user_email: '',
        partner_user_status: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    var array = [];
    for(var i=0; i<originFileRows.length; i++){
      var tmp_id = originFileRows[i].id;
      var tmp_file_name_sever = originFileRows[i].file_name_sever;
      var tmp_file_name = originFileRows[i].file_name;
      var tmp_file_size = originFileRows[i].file_size;
      var tmp_file_size_dp = originFileRows[i].file_size_dp;
      var tmp_file_type = originFileRows[i].file_type;
      var tmp_file_type_name  = originFileRows[i].file_type_name;
      var tmp_file_extension = originFileRows[i].file_extension;
      var tmp_file_reg_user_name = originFileRows[i].reg_user_name;
      var tmp_file_reg_datetime = originFileRows[i].reg_datetime;

      var tmpYN = 'N'
      for(var j=0; j<fileRows.length; j++){
        //origin에는 있고 file에는 없으면 -> O / D
        if(fileRows[j].id === originFileRows[i].id && fileRows[j].file_name_sever === originFileRows[i].file_name_sever && fileRows[j].reg_user_name === originFileRows[i].reg_user_name && fileRows[j].reg_datetime === originFileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        array.push({
          id: tmp_id,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_file_reg_user_name,
          reg_datetime: tmp_file_reg_datetime,
          row_type:'O',
          update_type: 'D'
        })
      }
    }

    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      var tmpYN = 'N'
      for(var j=0; j<originFileRows.length; j++){
        if(originFileRows[j].id === fileRows[i].id && originFileRows[j].file_name_sever === fileRows[i].file_name_sever && originFileRows[j].reg_user_name === fileRows[i].reg_user_name && originFileRows[j].reg_datetime === fileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){ // 신규Row(A, N)는 제외함.
          array.push({
            id: tmp_id,
            file_name_sever: tmp_file_name_sever,
            file_size: tmp_file_size,
            file_type: tmp_file_type,
            file_extension: tmp_file_extension,
            file_type_name: tmp_file_type_name,
            file_name: tmp_file_name,
            file_size_dp: tmp_file_size_dp,
            reg_user_name: tmp_file_reg_user_name,
            reg_datetime: tmp_file_reg_datetime,
            row_type:'A',
            update_type: 'U'
          })
        }
      }
    }
    setUpdateFileRows(array);
    
    let ADD_YN = 'Y'
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N' && i === (fileRows.length-1)){
        ADD_YN = 'N'
      }else if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        setFileRows((fileRows) => fileRows.filter((data) => data.id !== fileRows[i].id));
        ADD_YN = 'N'
      }
    }
    
    if(ADD_YN === 'Y' && updateFlag){
      newFileID = Number(newFileID) + 1;
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(newFileID),
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onNumberChange = (e)=>{
    const {name, value} = e.target;
    var return_data = ''
    if(e.target.name === 'partner_number'){ // 사업자번호
        return_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,2})(\d{0,5})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }else if(e.target.name === 'partner_corp_number'){ // 법인코드
      return_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,6})(\d{0,7})$/g, "$1-$2")
        .replace(/(-{1,2})$/g, "");
    }else if(e.target.name === 'partner_ceo_phone'){ // 대표자 휴대폰번호
      return_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: return_data, 
    };
    setInputs(nextInputs);
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'order_partner_manager_phone'){ // 휴대폰번호
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processAddressRowUpdate = (newRow, oldRow) => {
    //거래처 주소 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

    if(newRow.partner_address_nickname !== oldRow.partner_address_nickname || newRow.partner_address_post !== oldRow.partner_address_post || newRow.partner_address !== oldRow.partner_address || newRow.partner_address_addition !== oldRow.partner_address_addition){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_partner_address_nickname = '';
      var row_partner_address_post = '';
      var row_partner_address = '';
      var row_partner_address_addition = '';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if((newRow.partner_address_nickname).trim() !== '' || (newRow.partner_address_post).trim() !== '' || (newRow.partner_address).trim() !== '' || (newRow.partner_address_addition).trim() !== ''){
          row_partner_address_nickname = (newRow.partner_address_nickname).trim();
          row_partner_address_post = (newRow.partner_address_post).trim();
          row_partner_address = (newRow.partner_address).trim();
          row_partner_address_addition = (newRow.partner_address_addition).trim();
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        // console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        addressRows.map((data) => data.id === newRow.id 
          && ((data.partner_address_nickname).trim() !== (newRow.partner_address_nickname).trim() || (data.partner_address_post).trim() !== (newRow.partner_address_post).trim() || (data.partner_address).trim() !== (newRow.partner_address).trim() || (data.partner_address_addition).trim() !== (newRow.partner_address_addition).trim())?
          (
            row_partner_address_nickname = (data.partner_address_nickname).trim(),
            row_partner_address_post = (data.partner_address_post).trim(),
            row_partner_address = (data.partner_address).trim(),
            row_partner_address_addition = (data.partner_address_addition).trim()
          ):""
        )
      }
      
      if((row_partner_address_nickname).trim() === '' && (row_partner_address_post).trim() === '' && (row_partner_address).trim() === '' && (row_partner_address_addition).trim() === ''){
        // 1. 값이 수정되지 않은 경우.
        if(updateAddressRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          // console.log('[updateRows 원복] ' + updateRows.length);
          setUpdateAddressRows(updateAddressRows.filter((data) => data.id !== newRow.id));
          setAddressRows(addressRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateAddressRows.length; i++) {
          if(updateAddressRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateRows.length);
          setUpdateAddressRows(updateAddressRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setAddressRows(addressRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateRows.length);
          setUpdateAddressRows(prevRows => [...prevRows, newUpdateDataArray]);
          setAddressRows(addressRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    //담당자 주소 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

    if(newRow.partner_user_name !== oldRow.partner_user_name || newRow.partner_user_type !== oldRow.partner_user_type || newRow.partner_user_call !== oldRow.partner_user_call || newRow.partner_user_phone !== oldRow.partner_user_phone || newRow.partner_user_email !== oldRow.partner_user_email || newRow.partner_user_status !== oldRow.partner_user_status){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_partner_user_name = '';
      var row_partner_user_type = 0;
      var row_partner_user_call = '';
      var row_partner_user_phone = '';
      var row_partner_user_email = '';
      var row_partner_user_status = '';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if((newRow.partner_user_name).trim() !== '' || (newRow.partner_user_type !== 0 && newRow.partner_user_type !== null) || (newRow.partner_user_call).trim() !== '' || (newRow.partner_user_phone).trim() !== '' || (newRow.partner_user_email).trim() !== '' || (newRow.partner_user_status !== '' && newRow.partner_user_status !== null)){
          row_partner_user_name = (newRow.partner_user_name).trim();
          row_partner_user_type = newRow.partner_user_type;
          row_partner_user_call = (newRow.partner_user_call).trim();
          row_partner_user_phone = (newRow.partner_user_phone).trim();
          row_partner_user_email = (newRow.partner_user_email).trim();
          row_partner_user_status = newRow.partner_user_status;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        userRows.map((data) => data.id === newRow.id 
          && ((data.partner_user_name).trim() !== (newRow.partner_user_name).trim() || data.partner_user_type !== newRow.partner_user_type || (data.partner_user_call).trim() !== (newRow.partner_user_call).trim() || (data.partner_user_phone).trim() !== (newRow.partner_user_phone).trim() || (data.partner_user_email).trim() !== (newRow.partner_user_email).trim() || data.partner_user_status !== newRow.partner_user_status)?
          (
            row_partner_user_name = (data.partner_user_name).trim(),
            row_partner_user_type = data.partner_user_type,
            row_partner_user_call = (data.partner_user_call).trim(),
            row_partner_user_phone = (data.partner_user_phone).trim(),
            row_partner_user_email = (data.partner_user_email).trim(),
            row_partner_user_status = data.partner_user_status
          ):""
        )
      }
      
      if((row_partner_user_name).trim() === '' && (row_partner_user_type === 0 || row_partner_user_type === null) && (row_partner_user_call).trim() === '' && (row_partner_user_phone).trim() === '' && (row_partner_user_email).trim() === '' && (row_partner_user_status === '' || row_partner_user_status === null)){
        // 1. 값이 수정되지 않은 경우.
        if(updateUserRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateUserRows.length);
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const addressAddClick = (object) => {
    //거래처 주소 추가 버튼
    setAddressRows((addressRows) => [...addressRows, { 
      id: Number(appStore.getMaxListID(addressRows))+1,
      partner_address_nickname: '',
      partner_address_post: '',
      partner_address: '',
      partner_address_addition: '',
      reg_user_name: '',
      reg_datetime: '',
      row_type:'A',
      update_type: 'N'
    }]);
  };

  const addressDeleteClick = (object) => {
    //거래처 주소 삭제 버튼
    setUpdateAddressRows((updateAddressRows) => updateAddressRows.filter((data) => data.id !== object.row.id));
    if(object.row.row_type === 'O'){
      setUpdateAddressRows(prevRows => [...prevRows, {
        id: object.row.id,
        partner_address_nickname: (object.row.partner_address_nickname).trim(),
        partner_address_post: object.row.partner_address_post,
        partner_address: (object.row.partner_address).trim(),
        partner_address_addition: (object.row.partner_address_addition).trim(),
        reg_user_name: (object.row.reg_user_name).trim(),
        reg_datetime: (object.row.reg_datetime).trim(),
        row_type:'O',
        update_type: 'D'
      }]);
    }
    setAddressRows((addressRows) => addressRows.filter((data) => data.id !== object.row.id));
  };

  const userAddClick = (object) => {
    //거래처 담당자 추가 버튼
    setUserRows((userRows) => [...userRows, { 
      id: Number(appStore.getMaxListID(userRows))+1,
      partner_user_name: '',
      partner_user_type: 0,
      partner_user_call: '',
      partner_user_phone: '',
      partner_user_email: '',
      partner_user_status: '',
      row_type:'A',
      update_type: 'N'
    }]);
  };

  const userDeleteClick = (object) => {
    //거래처 담당자 삭제 버튼
    setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    if(object.row.row_type === 'O'){
      setUpdateUserRows(prevRows => [...prevRows, {
        id: object.row.id,
        partner_user_name: (object.row.partner_user_name).trim(),
        partner_user_type: object.row.partner_user_type,
        partner_user_call: (object.row.partner_user_call).trim(),
        partner_user_phone: (object.row.partner_user_phone).trim(),
        partner_user_email: (object.row.partner_user_email).trim(),
        partner_user_status: object.row.partner_user_status,
        row_type:'O',
        update_type: 'D'
      }]);
    }
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };
  
  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {
      tmpRealFiles = []; // 수정은 초기화용과 업로드용을 따로 둔다.
      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
        tmpRealFiles.push(input.files[i]);
      }

      var array = [];
      for(var i=0; i<tmpRealFiles.length; i++){
        var tmp_sever_file_name = tmpRealFiles[i].name;
        var tmp_file_name = tmpRealFiles[i].name;
        var tmp_file_size = tmpRealFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(tmpRealFiles[i].size);
        var tmp_file_type = tmpRealFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(tmpRealFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);
        
        newFileID = Number(newFileID) + 1;
        array.push({
          id: Number(newFileID),
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        });
      }
      setFileRows((fileRows) => [...fileRows, ...array]);
    };
  };

  const fileDeleteClick = (object) => {
    //파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }

    if(object.row.row_type === 'O'){
      setUpdateFileRows(prevRows => prevRows.some(r => r.id === object.row.id && r.update_type === 'D') ? prevRows : [...prevRows, { 
        id: object.row.id,
        file_name_sever: object.row.partner_file_name_sever,
        file_size: object.row.partner_file_size,
        file_type: object.row.partner_file_type,
        file_extension: object.row.partner_file_extension,
        file_name: object.row.partner_file_name,
        file_type_name: object.row.partner_file_type_name,
        file_size_dp: object.row.partner_file_size_dp,
        reg_user_name: object.row.partner_file_user_name,
        reg_datetime: Moment(object.row.partner_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
        row_type: 'O',
        update_type: 'D'
       }]);
    }else{
      setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    }
    
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //파일 다운로드
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };

  const handlePWReset = () => {
    axios.post("/api/p/Partner/PWReset", new URLSearchParams({
      update_partner_id: id
   }),
   { withCredentials: true })
    .then(function (response) {
        if(response.status === 200){
          Swal.fire({
            title: '거래처 비밀번호 초기화 완료',
            text: '정상적으로 비밀번호가 초기화 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleInitSelect();
            handleView();
          });
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
    });
  };

  const handleSave = (event) => {
    let msg = '';
    if((inputs.partner_name).trim() === ''){
      msg = '거래처명은 필수 입력 값 입니다.'
    }else if(inputs.partner_name === 0){
      msg = '거래처유형은 필수 선택 입니다.'
    }else if((inputs.partner_number).trim() === ''){
      msg = '사업자번호는 필수 입력 값 입니다.'
    }else if(inputs.partner_number.trim() !== '' && !(/^\d{3}-(\d{2})-\d{5}$/).test(inputs.partner_number.trim())){
      msg = '사업자번호 입력이 올바르지 않습니다.<br/>(입력 양식 : ex) 999-99-99999 하이픈 포함)';
    }else if(inputs.partner_corp_number.trim() !== '' && !(/^\d{6}-(\d{7})$/).test(inputs.partner_corp_number.trim())){
      msg = '법인코드 입력이 올바르지 않습니다.<br/>(입력 양식 : ex) 999999-9999999 하이픈 포함)';
    }
    
    if(updateAddressRows.length > 0 && msg === ''){
      for(let i = 0; i < addressRows.length; i++) {
        const currElem = (addressRows[i].partner_address_nickname).trim();
        for(let j = i+1; j < addressRows.length; j++) {
          if(currElem === (addressRows[j].partner_address_nickname).trim() && currElem !== '') {
            msg = '중복된 주소별칭이 존재합니다.<br/>[중복된 주소별칭 : '+currElem+']';
            break;
          }
        }

        if(msg !== '')  {
          break;
        }
      }

      for(let i = 0; i < updateAddressRows.length; i++) {
        const currElem = (updateAddressRows[i].partner_address_nickname).trim();
        if(currElem === '') {
          msg = '입력되지 않은 주소별칭이 존재합니다.';
          break;
        }
      }
    }
    
    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < userRows.length; i++) {
        const currElem = (userRows[i].partner_user_name).trim();
        for(let j = i+1; j < userRows.length; j++) {
          if(currElem === (userRows[j].partner_user_name).trim() && currElem !== '') {
            msg = '중복된 담당자명이 존재합니다.<br/>[중복된 담당자명 : '+currElem+']';
            break;
          }
        }

        if(msg !== '')  {
          break;
        }
      }

      for(let i = 0; i < updateUserRows.length; i++) {
        const currElem = updateUserRows[i].partner_user_name;
        if(currElem === '') {
          msg = '입력되지 않은 담당자명이 존재합니다.';
          break;
        }
        const currType = updateUserRows[i].partner_user_type;
        if(currType === 0) {
          msg = '선택되지 않은 담당자유형이 존재합니다.';
          break;
        }
        const currStau = updateUserRows[i].partner_user_status;
        if(currStau === 0) {
          msg = '선택되지 않은 담당자상태가 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">거래처 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      axios.post("/api/p/Partner/Update", {inputs, updateAddressRows, updateUserRows} ,
        { withCredentials: true })
        .then(function (response) {
          if(response.status === 200){

            if(updateFileRows.length > 0) {

              var selectID = inputs.partner_id;
              const formData = new FormData();
              formData.append('selectID', selectID);
              formData.append('folder', 'Partner');
              formData.append('type', 'Update');
              formData.append('updateFileRows', JSON.stringify(updateFileRows));
              
              for(var i=0; i<realFiles.length; i++){            
                formData.append('files', realFiles[i]);
              }
              
              axios.post('/api/SaveCommon/GridFileSave'
                  , formData
                  , { headers: { 'Content-Type': 'multipart/form-data' } 
              }).then(response => {
                Swal.fire({
                  title: '거래처 수정 완료',
                  text: '정상적으로 거래처가 수정 되었습니다.',
                  confirmButtonText: '확인',
                  timer:5000,
                  timerProgressBar: true
                }).then((result) => {
                  handleView();
                });
              }).catch(error => {
                appStore.capture();
              });
  
            }else{
  
              Swal.fire({
                title: '거래처 수정 완료',
                text: '정상적으로 거래처가 수정 되었습니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
              }).then((result) => {
                handleView();
              });
              
            }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      });

    }
  };

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="거래처 정보" value="1" />
                <Tab label="거래처 주소" value="2" />
                <Tab label="거래처 담당자" value="3" />
                <Tab label="거래처 파일" value="4" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">거래처명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="거래처" value={inputs.partner_name} name="partner_name" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">거래처유형<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="거래처유형" value={typeModalOption.filter(function (option) { return option.value === inputs.partner_type;  })} onChange={(e) => onSelectChange('partner_type',e.value)} options={typeModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">사업자번호<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="사업자번호" value={inputs.partner_number} name="partner_number" onChange={(e) => onNumberChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">법인코드</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="법인코드" value={inputs.partner_corp_number} name="partner_corp_number" onChange={(e) => onNumberChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">전화번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="전화번호" value={inputs.partner_call} name="partner_call" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">팩스번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="팩스번호" value={inputs.partner_fax} name="partner_fax" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">대표자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="이름" value={inputs.partner_ceo} name="partner_ceo" onChange={(e) => onChange(e) } style={{ float: 'left', width: '112px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="휴대폰번호" value={inputs.partner_ceo_phone} name="partner_ceo_phone" onChange={(e) => onNumberChange(e) } style={{ float: 'left', width: '300px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="메일주소" value={inputs.partner_ceo_email} name="partner_ceo_email" onChange={(e) => onChange(e) } style={{width: '360px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">주소</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="우편번호" value={inputs.partner_head_address_post} name="partner_head_address_post" onChange={(e) => onChange(e) } style={{ float: 'left', width: '112px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="주소" value={inputs.partner_head_address} name="partner_head_address" onChange={(e) => onChange(e) } style={{ float: 'left', width: '300px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="상세주소" value={inputs.partner_head_address_addition} name="partner_head_address_addition" onChange={(e) => onChange(e) } style={{width: '360px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">업태</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="업태" value={inputs.partner_business_type} name="partner_business_type" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">종목</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="종목" value={inputs.partner_industry} name="partner_industry" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">메모</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="메모" value={inputs.partner_note} name="partner_note" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={addressRows}
                  columns={addressColumns}
                  columnVisibilityModel={addressColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processAddressRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
             <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    {/*
                    <div className="modal_button" style={{float: 'left'}}>
                      <Button 
                        onClick={ handlePWReset }
                        className="btn-p btn-u"
                        style={{width: '170px'}}
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#0067a3", 
                            backgroundColor: "#0067a3",
                            ":hover": { boxShadow: "2px 2px 2px #0067a3" , backgroundColor: "#0067a3", borderColor: "#0067a3"}
                        }} 
                        variant="outlined">
                        비밀번호 초기화
                      </Button>
                    </div>
                    */}
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {updateFlag &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        수정
                      </Button>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </PCModal>
  );
}

export default PartnerUpdateModal;